import React, { Component } from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';

export default function (WrappedConfigurationComponent) {
    class ConfigurationInputField extends Component {
        render() {
            const {
                input,
                inputComponent,
                meta,
                ...restProps
            } = this.props;

            const props = {
                ...input,
                ...meta,
                ...restProps,
            };

            if (inputComponent) {
                props.component = inputComponent;
            }

            if (utils.isArray(props.value)) {
                props.values = props.value;
                delete props.value;
            }

            return React.createElement(WrappedConfigurationComponent, {
                ...props,
            });
        }
    }

    ConfigurationInputField.propTypes = {
        input: PropTypes.shape({
            value: PropTypes.any,
        }),
        inputComponent: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.func,
            PropTypes.node,
        ]),
        meta: PropTypes.object,
    };

    return ConfigurationInputField;
}



// WEBPACK FOOTER //
// ./src/pages/products/configuration/ConfigurationInputField.js